export default {
  klarna: () => import('./klarna'),
  paybright: () => import('./paybright'),
  billie: () => import('./billie')
}
